<template>

    <div class="_wiki">

     <div class="c" v-html="htmlData">

     </div>

   </div>

 </template>

<script>

import WikiApi from '../api/Wiki';

export default {

    name: 'Wiki',

    components:

   {

   },

    data()

    {
        return {

            htmlData: '',

            header: '',

        };
    },

    async created()

    {
        const me = this;

        try

        {
            const data = await WikiApi.getWikiByName(me.$route.params.wikiname);

            if (data.error === false)

            {
                me.htmlData = data.data.content;

                me.header = data.data.header;
            }

            else

            {
                throw (data);
            }
        }

        catch (error)

        {
            me.htmlData = me.$t('CANNOTFINDARTICLE');
        }
    },

};

</script>
